<template>
      <v-layout row wrap justify-center align-center>
          <v-flex xs12>
             <v-card class='mb-2'>
                  <v-card-title class="ml-4">
                    <v-flex xs10 justify-center align-center class='text-xs-center'> 
                      <h1>{{unidadeData.name}}
                        <v-icon
                          v-if="!editing && !isMakerlab"
                          style="position: fixed; right: 3rem"
                          size="30"
                          @click="urlCalendar" 
                          class="mr-2; align-end"
                        >
                          calendar_today
                        </v-icon>
                      </h1>
                    </v-flex>
                    <v-flex xs2 v-if="editing">
                      <v-icon
                        v-if="permissao"
                        size="25"
                        @click="dialog = true"
                        style="float: right" 
                      >
                        delete
                      </v-icon>                      
                    </v-flex>
                    <v-flex xs6 justify-start>
                      <profile-text title="Logradouro :" v-model='unidadeData.logradouro'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Número :" v-model='unidadeData.numero'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Complemento :" v-model='unidadeData.complemento'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                      <profile-text title="CEP :" v-model='unidadeData.cep'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Bairro :" v-model='unidadeData.bairro'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Secretaria responsável:" v-model='nameSec'
                        v-if="!editing"
                        :last='true'
                        input-type='multilinetext'></profile-text>
                      <v-autocomplete
                        v-if="editing"
                        :items="secretaria"
                        v-model="unidadeData.secretaria_responsavel"
                        label="Selecione a secretaria responsável"
                        item-text="username"
                        item-value="id"
                        chips
                        max-height="auto"
                        style="width: 94%"
                      > </v-autocomplete>
                      
                    </v-flex>
                    <v-flex xs6 justify-start>
                      <profile-text title="Cidade :" v-model='unidadeData.cidade'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Telefone :" v-model='unidadeData.phonenumber'
                        :last='true'
                        :editing='editing'
                        mask="(##) #####-####"
                        input-type='multilinetext'></profile-text>  
                      <profile-text title="Horário de Funcionamento :" v-model='unidadeData.horariofunc'
                        :last='true'
                        :editing='editing'
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Tipo :" v-model='unidadeData.tipo_readable'
                        :last='true'
                        input-type='multilinetext'></profile-text> 
                      <profile-text title="E-mail :" v-model='unidadeData.email'
                        :last='true'
                        :editing='editing  && !isMakerlab'
                        input-type='multilinetext'></profile-text>
                        <v-autocomplete
                        v-if="editing   && !isMakerlab"
                        label="Ano(s)"
                        :items="ano"
                        item-text="name"
                        item-value="slug"
                        v-model="unidadeData.ano"
                        max-height="400"
                        multiple
                        hint="Escolha o(s) ano(s)"
                        persistent-hint
                        ></v-autocomplete>
                        <profile-text title="Situação :" v-model='situacao'
                        :last='true'
                        v-if="!editing && permissao"
                        input-type='multilinetext'></profile-text>
                    </v-flex>
                    <v-flex xs6>
                      <div v-if="!editing && permissao">                    
                        <p>
                          <strong style="font-size: 1.2rem">Empresa : </strong>
                          <v-chip
                            @click="goToCompany(unidadeData.company)"
                            v-if="unidadeData.company"  
                            desable 
                            color='orange'
                            outline>
                                {{filtrado()}}
                          </v-chip>
                        </p>
                      </div>
                      <div v-if="editing   && !isMakerlab">
                        <p>
                          <strong style="font-size: 1.2rem">Empresa : </strong>
                        </p>
                        <v-autocomplete
                          :items="empresa"
                          v-model="unidadeData.company"
                          label="Selecione o responsável"
                          item-text="name"
                          item-value="id"
                          max-height="auto"
                          style="width: 94%"
                        > </v-autocomplete>
                      </div>

                      <div v-if="!editing">
                        <p>
                          <strong style="font-size: 1.2rem">Programas : </strong>
                          <v-chip 
                            v-if="!editing"
                              v-for="un 
                              in unidadeData.programa"
                              :key='un.id'
                              desable 
                              @click="goToPrograma(un)"
                              label
                              color='amber'
                              outline>
                                  {{un}}
                            </v-chip>
                        </p>
                      </div>
                      <div v-if="editing   && !isMakerlab">
                        <p>
                          <strong style="font-size: 1.2rem">Programas : </strong>
                        </p>
                        <v-autocomplete
                          :items="availableprogramas"
                          v-model="unidadeData.programa"
                          label="Selecione os programas"
                          item-text="slug"
                          item-value="slug"
                          chips
                          multiple
                          max-height="auto"
                          style="width: 94%"
                        > </v-autocomplete>
                      </div>

                    </v-flex>
                    <v-flex xs6>
                      <div style="height: 1rem"></div>  
                      
                      <div v-if="!editing">                    
                        <p>
                          <strong style="font-size: 1.2rem">Responsavel : </strong>
                          <v-chip
                            v-if="unidadeData.responsavel"  
                            desable 
                            @click="goToUser(unidadeData.responsavel)"
                            color='blue'
                            outline>
                                {{unidadeData.responsavel}}
                          </v-chip>
                        </p>
                        <p>
                        <strong style="font-size: 1.2rem">Ano: </strong>
                      <!-- <a href="#" 
                        > -->
                      <!-- @click.prevent="goToUnidade(un.slug)"> -->
                          <v-chip label
                          v-for="un 
                          in anoOrder"
                          :key='un.name'
                          desable 
                          color='primary'
                          outline>
                              {{un.name}}
                          </v-chip>
                      <!-- </a> -->
                      </p>
                      </div>
                      <div v-if="editing  && !isMakerlab">
                        <p>
                          <strong style="font-size: 1.2rem">Responsavel : </strong>
                        </p>
                        <v-autocomplete
                          :items="usuario"
                          v-model="unidadeData.responsavel"
                          label="Selecione o responsável"
                          item-text="username"
                          item-value="username"
                          chips
                          max-height="auto"
                          style="width: 94%"
                        > </v-autocomplete>
                      </div> 
                      <br>
                      <h3 v-if="editing   && !isMakerlab" >Deseja Bloquear?</h3> 
                        <v-switch
                        v-if="editing  && !isMakerlab"
                        v-model="unidadeData.flag_bloqueado"
                        color="red"
                        label="Bloquear?"></v-switch>   

                    </v-flex>
                          
                      
                      
                  </v-card-title>
                   <v-btn
                      absolute
                      dark
                      fab
                      bottom
                      right
                      color="blue"
                      @click="pressFloatingButton()"
                      >
                      <v-icon v-if='!editing'>mode_edit</v-icon>
                      <v-icon v-else>done</v-icon>
                    </v-btn>  
                      <!-- <v-btn
                      v-if="isMakerlab"
                      absolute
                      dark
                      fab
                      bottom
                      right
                      color="blue"
                      @click="dialogSec = true"
                      >
                      <v-icon v-if='!editing'>mode_edit</v-icon>
                      <v-icon v-else>done</v-icon>
                    </v-btn>   -->
              </v-card>
          </v-flex>
          <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline">Deseja deletar?</v-card-title>
              <v-card-text>Gostaria excluir essa turma?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat @click.native="dialog = false">Cancelar</v-btn>
                <v-btn color="green darken-1" flat @click.native="excluir()">Deletar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Secretaria responsável -->
          <v-dialog v-model="dialogSec" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">Deseja adicionar secretaria?</v-card-title>
              <v-card-text>
                <p>
                  <strong style="font-size: 1.2rem">Secretaria responsavel : </strong>
                </p>
                <v-autocomplete
                  :items="secretaria"
                  v-model="unidadeData.secretaria_responsavel"
                  label="Selecione a secretaria responsável"
                  item-text="username"
                  item-value="id"
                  chips
                  max-height="auto"
                  style="width: 94%"
                > </v-autocomplete>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat @click.native="dialogSec = false">Cancelar</v-btn>
                <v-btn color="green darken-1" flat @click.native="performSave2()">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-layout>
</template>

<script>

import api from '@/api'
import ProfileText from '@/components/reusable/ProfileText.vue'
export default {
  components: {
    ProfileText
  },
  data () {
    return {
      unidadeData: {
        parent: '',
        responsavel: ''
      },
      currentTab: 'Sobre',
      showImageUpload: false,
      imageChangeModal: false,
      editing: false,
      nameSec: '',
      avaliando: false,
      dialog: false,
      dialogSec: false,
      tempData: {},
      anoGeral: [],
      options: {},
      usuario: {},
      secretaria: [],
      evidencias: {},
      criterios: {},
      availableprogramas: {},
      ano: {},
      situacao: '',
      empresa: [],
      page: 1
    }
  },
  mounted () {
    var projectid = this.$route.params.slug
    api.request('GET', 'unidade/' + projectid + '/').then(response => {
      this.unidadeData = response.data
      console.log(this.unidadeData)
      this.bloqueado()
    })
    api.request('GET', 'search-user?groups__name=Admin').then((response) => {
      this.usuario = response.data
    })
    api.request('GET', 'search-user?groups__name=Secretaria').then((response) => {
      this.secretaria = response.data
      setTimeout(() => {
        this.secretariaName()
      }, 300);
    })
    api.request('GET', 'companies/').then(response => {
      this.empresa = response.data
    })
    api.request('GET', 'ano/').then(resp => {
      resp.data.sort((a, b) => (a.order_number > b.order_number) ? 1 : ((b.order_number > a.order_number) ? -1 : 0))
      this.ano = resp.data
    })
    api.request('GET', 'programas/').then(resp => {
      this.availableprogramas = resp.data
    })
    api.request('GET', 'ano/').then(response => {
      response.data.sort((a, b) => (a.order_number > b.order_number) ? 1 : ((b.order_number > a.order_number) ? -1 : 0))
      this.anoGeral = response.data
    })
  },
  watch: {
  },
  computed: {
    permissao () {
      return this.$store.state.user.is_superuser
    },
    anoOrder () {
      var order = []
      for (let i = 0; i < this.anoGeral.length; i++) {
        for (let index = 0; index < this.unidadeData.ano.length; index++) {
          if (this.anoGeral[i].name === this.unidadeData.ano[index]) {
            order.push(this.anoGeral[i])
          }
        }
      }
      return order
    },
    isMakerlab () {
      return this.$store.state.company.makerlab;
    }
  },
  methods: {
    goToPrograma (programa) {
      this.$router.push('/programas/' + programa)
    },
    goToCompany (empresa) {
      this.$router.push('/empresas/' + empresa)
    },
    goToUser (user) {
      this.$router.push('/usuarios/' + user)
    },
    urlCalendar () {
      this.$router.push('/calendario/unidade/' + this.unidadeData.slug)
    },
    pressFloatingButton () {
      if (this.editing) {
        this.performSave()
      } else {
        this.editing = !this.editing
      }
    },
    bloqueado () {
      if (this.unidadeData.flag_bloqueado) {
        this.situacao = 'Bloqueado'
      } else {
        this.situacao = 'Regular'
      }
    },
    secretariaName () {
      var username = ''
      username = this.secretaria.filter(v => {
        if (v.id !== undefined) {
          if (v.id === this.unidadeData.secretaria_responsavel) {
            return v.username
          }
        }
      })
      this.nameSec = username[0].username
    },
    performSave () {
      var slugid = this.$route.params.slug
      if (this.unidadeData.responsavel === null) {
        delete this.unidadeData.responsavel
      }
      delete this.unidadeData.parent
      let self = this
      api
        .request('PATCH', 'unidade/' + slugid + '/', this.unidadeData)
        .then(function (response) {
          self.refreshUI()
          // console.log(response)
        })
    },
    performSave2 () {
      var slugid = this.$route.params.slug
      api
        .request('POST', 'unidade/' + slugid + '/change_secretary/', {
          secretary: this.unidadeData.secretaria_responsavel
        })
        .then(response => {
          this.refreshUI()
          // console.log(response)
        })
    },
    excluir () {
      api.request('DELETE', 'unidade/' + this.$route.params.slug + '/').then(resp => {
        this.$router.push('/unidades')
      })
    },
    getUser (username) {
      var userarray = this.unidadeData.integrantes.filter(value => {
        return value.username === username
      })
      return userarray[0]
    },
    refreshUI () {
      var projectslug = this.$route.params.slug
      api.request('GET', 'unidade/' + projectslug + '/').then(response => {
        this.unidadeData = response.data
        this.bloqueado()
        this.secretariaName()
        this.editing = false
        this.dialogSec = false
      })
    },
    filtrado () { // mapeamento
      var userarray = this.empresa.filter(value => {
        return value.id === this.unidadeData.company
      })
      return userarray[0].name
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Unidades/Detail.vue